'use strict';

var base = require('../product/base');
var focusHelper = require('base/components/focus');
var qtySelect = require('../components/quantitySelect');
var addToCartTooltip = require('../product/addToCartTooltip');
var colorSwatchTooltip = require('../product/colorSwatchTooltip');
var specialSelect = require('../components/specialSelect');
var embroidery = require('org/product/embroidery');
var tooltipOptions = {
    offset: '0, 20px'
};
var shippingHelpers = require('../checkout/shipping');
var debounce = require('lodash/debounce');
var recycleCouponCode = require('../util/recycleCouponCode');

var cache = {
    $document: $(document)
};

/**
 * Animate Progess Bar
 * @param {Object} w - Value now
 */
function animateProgressBar(w) {
    setTimeout(function () {
        $('.shipping-progress-bar .progress-bar').attr({
            style: 'width: ' + w + '%',
            'aria-valuenow': w
        });
    }, 500);
}

/**
 * Updates Free Shipping Progess Bar
 * @param {string} e - event
 * @param {string} cartData - cart data
 * @param {number} apiMinFree - ajax minFreeData
 */
function updateFreeShippingProgressBar(e, cartData, apiMinFree) {
    var html;
    /**
     * Updates Free Shipping Progress Bar avoiding null values in text
     * @param {string} text - text to display
     * @param {number} progress - progress value
     */
    function setBar(text, progress) {
        var $el = $('.shipping-progress-bar span');
        if (!$el.length) return;
        var msg = (typeof text === 'string') ? text : '';
        if (!msg || /(^|\b)null(\b|$)/i.test(msg)) {
            msg = '';
        }
        $el.html(msg);
        animateProgressBar(progress);
    }
    if (apiMinFree && apiMinFree < 0) {
        $('.shipping-progress-bar').hide();
    } else {
        $('.shipping-progress-bar').show();
    }
    var locale = cartData.locale;
    var currency = (cartData.items && cartData.items.length) ? cartData.items[0].price.sales.currency : 'USD';
    var subTotal = cartData.freeShippingContext.merchSubtotal;
    var totalShippingCost = cartData.freeShippingContext.shippingRate;
    var resources = cartData.freeShippingContext.resources || {};
    if (apiMinFree && apiMinFree > 0 && apiMinFree - subTotal <= 0) {
        if (totalShippingCost === 0) {
            html = resources.full;
            setBar(html, 100);
        }
    } else if (apiMinFree && apiMinFree && apiMinFree - subTotal > 0) {
        var toGoForFreeShipping = Number(apiMinFree - subTotal);
        var progressValueNow = Math.round(((apiMinFree - toGoForFreeShipping) * 100) / apiMinFree);
        html = resources.used;

        locale = locale.replace('_', '-');
        toGoForFreeShipping = new Intl.NumberFormat(locale, { style: 'currency', currency: currency }).format(toGoForFreeShipping);
        setBar((html || '').replace('{0}', toGoForFreeShipping || ''), progressValueNow);
    } else {
        html = resources.empty;
        setBar((html || '').replace('{0}', apiMinFree || ''), 0);
    }
}

/**
 * Updates shipping methods on checkout, but only if the shipping
 * method list is currently visible. This is necessary because the
 * shipping method list is rendered in a separate request, and thus
 * we need to update the shipping methods when the list is visible.
 */
function updateShippingMethodsOnCheckout() {
    // update checkout shipping methods if visible
    const closestShippingForm = $('.shipping-method-list').closest('form:visible');
    if (closestShippingForm.length) {
        shippingHelpers.methods.updateShippingMethodList(closestShippingForm);
    }
}
/**
 * Updates PayPal Pay Later message amount
 * @param {Object} data - AJAX response from the server
 */
function updatePayPalPayLaterAmount(data) {
    var $paypalMessage = $('[data-pp-message][data-pp-placement="cart"]');
    if ($paypalMessage.length && data.totals && data.totals.grandTotal) {
        var grandTotalStr = data.totals.grandTotal;
        var newAmount = parseFloat(grandTotalStr.replace(/[^0-9.-]+/g, ''));
        if (!isNaN(newAmount)) {
            $paypalMessage.attr('data-pp-amount', newAmount);
        }
    }
}

/**
 * re-renders the order totals and the number of items in the cart
 * @param {Object} data - AJAX response from the server
 */
function updateCartTotals(data) {
    $('.order-savings').find('span:eq(1)').html(data.totalSavings.value);
    $('.total-savings').html(data.totalSavings.value);
    $('.order-discount-total').empty().append(data.totalSavings.orderSummaryDiscount || data.totalSavings.valueWithPromo);
    $('.number-of-items').empty().append(data.resources.numberOfItems);
    if ($('.shipping-cost').length === 1) {
        $('.shipping-cost').empty().append(data.totals.totalShippingCost);
    }
    $('.tax-total').empty().append(data.totals.totalTax);
    $('.grand-total').each(function () {
        var $sum = $(this).find('.grand-total-sum');
        ($sum.length ? $sum : $(this)).text(data.totals.grandTotal);
    });
    $('.place-order-total').empty().append(data.totals.grandTotal);
    $('.sub-total').empty().append(data.totals.subTotal);
    $('.order-total').empty().append(data.orderTotals);
    $('.digitize-cost').empty().append(data.totals.digitizeFeeObject);
    $('.minicart-quantity').empty().append(data.numItems);
    $('.minicart-link').attr({
        'aria-label': data.resources.minicartCountOfItems,
        title: data.resources.minicartCountOfItems
    });
    updatePayPalPayLaterAmount(data);
    if (data.totalSavings && data.totalSavings.orderSummaryDiscountTotal > 0) {
        $('.order-discount').removeClass('hide-order-discount');
        $('.order-discount-total').empty().append('- ' + data.totalSavings.orderSummaryDiscount);
    } else if (data.totalSavings) {
        $('.order-discount').addClass('hide-order-discount');
    }
    if (data.totalSavings.totalValue > 0) {
        $('.order-savings').removeClass('hide-order-discount');
        $('.subtotal-item').removeClass('hide-order-discount');
        $('.order-savings').find('span:eq(1)').html(data.totalSavings.value);
    } else {
        $('.order-savings').addClass('hide-order-discount');
        $('.subtotal-item').addClass('hide-order-discount');
    }
    if (data.totals.orderLevelSFCCPromos && data.totals.orderLevelSFCCPromos.trim().length > 0) {
        $('.order-sfcc-promos').removeClass('hide-order-discount');
        $('.order-sfcc-savings').html(data.totals.orderLevelSFCCPromos);
    } else {
        $('.order-sfcc-promos').addClass('hide-order-discount');
    }
    if (data.totals.digitizeFeeObject === '-') {
        $('.digitize-total-item').addClass('d-none');
        $('.digitize-cart-price').empty().append(data.totals.zeroLocal);
    } else {
        $('.digitize-total-item').removeClass('d-none');
        $('.digitize-cart-price').empty().append(data.totals.digitizeUnitFeeObject || data.totals.digitizeFeeObject);
    }

    // Update Source Codes and Coupons
    $('.coupons-and-promos.source-code-list').empty().append(data.totals.discountsHtml);
    $('.coupons-and-promos.coupon-code-list').empty().append(data.totals.couponsHtml);

    // Sync coupon discount rows in order summary
    var $couponRows = $('.coupon-discount-rows');
    if ($couponRows.length && data.totals && Array.isArray(data.totals.discounts)) {
        var couponLabel = $couponRows.data('coupon-label') || 'Coupon';
        $couponRows.empty();
        data.totals.discounts.forEach(function (discount) {
            if (discount.type !== 'coupon' || !discount.applied || !discount.price) {
                return;
            }
            $couponRows.append(
                '<div class="row coupon-discount-item">' +
                    '<div class="col-8"><p class="order-receipt-label"><span class="text-danger">' + couponLabel + '</span></p></div>' +
                    '<div class="col-4"><p class="text-right"><span class="coupon-discount-total text-danger">- ' + discount.price + '</span></p></div>' +
                '</div>'
            );
        });
    }

    if (data.totals.shippingLevelDiscountTotal.value > 0) {
        $('.shipping-discount').removeClass('hide-shipping-discount');
        $('.shipping-discount-total').empty().append('- ' +
            data.totals.shippingLevelDiscountTotal.formatted);
    } else {
        $('.shipping-discount').addClass('hide-shipping-discount');
    }
    if (data.listItems) {
        data.listItems.forEach(function (listItem) {
            $('.item-price-' + listItem.UUID + ' .unit-price').empty().append(listItem.renderedPrice);
            if (listItem.totalEmbroideryPrice) {
                var embroideryTotalPriceObject = listItem.embroideryTotalPriceObject ? listItem.embroideryTotalPriceObject : '';
                if (embroideryTotalPriceObject && embroideryTotalPriceObject.list.value !== embroideryTotalPriceObject.sales.value) {
                    $('.embroidery-unit-total-' + listItem.UUID).empty().append(listItem.embroideryTotalHtml);
                } else {
                    $('.embroidery-unit-total-' + listItem.UUID).empty().append(listItem.embroideryPrice);
                }
                listItem.embroideryConfig.forEach(function (emb) {
                    if (emb.componentAttributes.length > 0) {
                        if (emb.price && emb.price.list) {
                            var embRenderedHtml = "<div class='price'><span class='price-main'><span class='strike-through list'>" +
                                "<span class='value' content='" + emb.price.list.value + "'><span class='sr-only'>Price reduced from</span>" +
                                emb.price.list.formatted + "<span class='sr-only'>to</span></span></span><span class='sales null'><span class='value' content='" +
                                emb.price.sales.value + "'>" + emb.price.sales.formatted + " </span></span></span></div>"; // eslint-disable-line
                            $('.embroidery-summary-' + listItem.UUID + ' .' + emb.component).empty().append(embRenderedHtml);
                        } else if (emb.price && emb.price.sales) {
                            $('.embroidery-summary-' + listItem.UUID + ' .' + emb.component).text(emb.price.sales.formatted);
                        }
                    }
                });
                $('.item-total-' + listItem.UUID).empty().append(listItem.priceObj.sales.formatted);
                $('.embroidery-total-' + listItem.UUID).empty().append(listItem.totalEmbroideryPrice);
            } else {
                $('.item-total-' + listItem.UUID).empty().append(listItem.priceObj.sales.formatted);
            }
        });
    }
    data.items.forEach(function (item) {
        if (item.renderedPromotions) {
            $('.item-' + item.UUID).empty().append(item.renderedPromotions);
        } else {
            $('.item-' + item.UUID).empty();
        }
        $('.uuid-' + item.UUID + ' .unit-price').empty().append(item.renderedPrice);
        $('.line-item-price-' + item.UUID + ' .unit-price').empty().append(item.renderedPrice);
        if (item.totalEmbroideryPrice && item.totalEmbroideryPrice.formattedValue) {
            var embroideryTotalPriceObject = data.embroideryTotalData ? data.embroideryTotalData.embroideryTotalPriceObject[item.UUID] : '';
            if (embroideryTotalPriceObject && embroideryTotalPriceObject.list && embroideryTotalPriceObject.list.value !== embroideryTotalPriceObject.sales.value) {
                $('.embroidery-unit-total-' + item.UUID).empty().append(data.embroideryTotalData.embroideryTotalHtml[item.UUID]);
            } else {
                $('.embroidery-unit-total-' + item.UUID).empty().append(item.embroideryPrice);
            }
            item.embroidery.forEach(function (emb) {
                if (emb.componentAttributes.length > 0) {
                    if (emb.price && emb.price.list) {
                        var embRenderedHtml = "<div class='price'><span class='price-main'><span class='strike-through list'>" +
                            "<span class='value' content='" + emb.price.list.value + "'><span class='sr-only'>Price reduced from</span>" +
                            emb.price.list.formatted + "<span class='sr-only'>to</span></span></span><span class='sales null'><span class='value' content='" +
                            emb.price.sales.value + "'>" + emb.price.sales.formatted + " </span></span></span></div>"; // eslint-disable-line
                        $('.embroidery-summary-' + item.UUID + ' .' + emb.component).empty().append(embRenderedHtml);
                    } else if (emb.price && emb.price.sales) {
                        $('.embroidery-summary-' + item.UUID + ' .' + emb.component).text(emb.price.sales.formatted);
                    }
                }
            });
            if (item.priceTotal && item.priceTotal.nonAdjustedPrice) {
                var lineItemTotalHtml = "<div class='strike-through'>" + item.priceTotal.nonAdjustedPrice + '</div>' +
                    "<div class='line-item-total-price-amount item-total-" + item.UUID + " adjusted-price sales sale'>" +
                    "<span class='" + (item.priceTotal.isSalePrice ? 'sales' : '') + "'>" +
                    item.lineItemTotalWithoutEmbroidery.formattedValue + '</span></div>';
                $('.item-total-' + item.UUID).empty().append(lineItemTotalHtml);
            } else {
                $('.item-total-' + item.UUID).empty().append(item.lineItemTotalWithoutEmbroidery.formattedValue);
            }
            $('.embroidery-total-' + item.UUID).empty().append(item.totalEmbroideryPrice.formattedValue);
        } else if (item.id === 'DIGITIZE') {
            $('.item-total-' + item.referenceGUID).empty().append(item.price.sales.formatted);
            $('.line-item-price-' + item.referenceGUID + ' .unit-price').empty().append(item.renderedPrice);
        } else {
            $('.item-total-' + item.UUID).empty().append(item.priceTotal.renderedPrice);
        }

        var $itemCard = $('.uuid-' + item.UUID);
        var $sourceCodeRow = $itemCard.find('.line-item-source-code');
        if (item.isDiscountPricingCodeApplied && item.discountSourceCode && item.discountedAmountFormatted) {
            var discountHtml = '<span><i class="fa fa-tag"></i> ' + item.discountSourceCode + '</span> ' +
                '<span class="text-danger">(-' + item.discountedAmountFormatted + ')</span>';
            if ($sourceCodeRow.length) {
                $sourceCodeRow.html(discountHtml);
            } else {
                $itemCard.find('.item-attributes').append(
                    '<p class="line-item-attributes line-item-source-code">' + discountHtml + '</p>'
                );
            }
        } else {
            $sourceCodeRow.remove();
        }
    });
}

/**
 * re-renders the approaching discount messages
 * @param {Object} approachingDiscounts - updated approaching discounts for the cart
 */
function updateApproachingDiscounts(approachingDiscounts) {
    var html = '';
    $('.approaching-discounts').empty();
    if (approachingDiscounts.length > 0) {
        approachingDiscounts.forEach(function (item) {
            html += '<div class="single-approaching-discount text-center">'
                + item.discountMsg + '</div>';
        });
    }
    $('.approaching-discounts').append(html);
}

/**
 * Checks whether the basket is valid. if invalid displays error message and disables
 * checkout button
 * @param {Object} data - AJAX response from the server
 */
function validateBasket(data) {
    if (data && data.addressvalid && data.addressvalid.addressError) {
        if (data && data.addressvalid && data.addressvalid.addressvalidMessage) {
            var error = '<div class="alert alert-danger alert-dismissible valid-cart-error ' +
                'fade show" role="alert">' +
                '<button type="button" class="close" data-dismiss="alert" aria-label="Close">' +
                '<span aria-hidden="true">&times;</span>' +
                '</button>' + data.addressvalid.addressvalidMessage + '</div>';

            $('.vetcor-addresserror').empty();
            $('.vetcor-addresserror').append(error);
        }
        if ('.vetcor-addresserror'.length) {
            $('.vetcor-addresserror').show();
        }
        $('.checkout-btn').addClass('disabled');
    } else {
        $('.checkout-btn').removeClass('disabled');
        $('.vetcor-addresserror').hide();
    }
    if (data.valid.error) {
        if (data.valid.message) {
            var errorHtml = '<div class="alert alert-danger alert-dismissible valid-cart-error ' +
                'fade show" role="alert">' +
                '<button type="button" class="close" data-dismiss="alert" aria-label="Close">' +
                '<span aria-hidden="true">&times;</span>' +
                '</button>' + data.valid.message + '</div>';

            $('.cart-error').append(errorHtml);
            $('.inventory-error').empty();
            $('.inventory-error').append(errorHtml);
        } else {
            $('.cart').empty().append('<div class="row"> ' +
                '<div class="col-12 text-center"> ' +
                '<h1>' + data.resources.emptyCartMsg + '</h1> ' +
                '</div> ' +
                '</div>'
            );
            $('.number-of-items').empty().append(data.resources.numberOfItems);
            $('.minicart-quantity').empty().append(data.numItems);
            $('.minicart-link').attr({
                'aria-label': data.resources.minicartCountOfItems,
                title: data.resources.minicartCountOfItems
            });
            $('.minicart .popover').empty();
            $('.minicart .popover').removeClass('show');
        }
        if ($('.inventory-error').length) {
            $('.cart-error').empty();
            $('.inventory-error').show();
        }
        $('.checkout-btn').addClass('disabled');
    } else if (data.valid && !data.valid.error && data && data.addressvalid && !data.addressvalid.addressError) {
        $('.checkout-btn').removeClass('disabled');
        $('.inventory-error').hide();
    }
}

/**
 * Changing Shipping methods dropdown
 * @param {Object} shipment - shipment object
 * @returns {string} resultHtml
 */
function changeShippingMethods(shipment) {
    var resultHtml = '';
    for (var i = 0; i < shipment.shippingMethods.length; i++) {
        var el = shipment.shippingMethods[i];
        if (el.ID === shipment.selectedShippingMethod) {
            resultHtml += '<option selected data-shipping-id="' + el.ID + '">' + el.displayName + '</option>';
        } else {
            resultHtml += '<option data-shipping-id="' + el.ID + '">' + el.displayName + '</option>';
        }
    }
    return resultHtml;
}

/**
 * re-renders the order totals and the number of items in the cart
 * @param {Object} message - Error message to display
 */
function createErrorNotification(message) {
    var errorHtml = '<div class="alert alert-danger alert-dismissible ' +
        'fade show" role="alert">' +
        '<button type="button" class="close" data-dismiss="alert" aria-label="Close">' +
        '<span aria-hidden="true">&times;</span>' +
        '</button>' + message + '</div>';

    $('.cart-error').empty().append(errorHtml);
}

/**
* cart edit modal error message
* @param {Object} message - Error message to display
*/
function cartEditErrorNotification(message) {
    var errorHtml = '<div class="alert alert-danger alert-dismissible valid-cart-error ' +
        'fade show" role="alert">' +
        '<button type="button" class="close" data-dismiss="alert" aria-label="Close">' +
        '<span aria-hidden="true">&times;</span>' +
        '</button>' + message + '</div>';
    $('.cart-edit-error').empty().append(errorHtml);
}

/**
 * appends params to a url
 * @param {string} url - Original url
 * @param {Object} params - Parameters to append
 * @returns {string} result url with appended parameters
 */
function appendToUrl(url, params) {
    var newUrl = url;
    newUrl += (newUrl.indexOf('?') !== -1 ? '&' : '?') + Object.keys(params).map(function (key) {
        return key + '=' + encodeURIComponent(params[key]);
    }).join('&');

    return newUrl;
}

/**
 * Updates the availability of a product line item
 * @param {Object} data - AJAX response from the server
 * @param {string} uuid - The uuid of the product line item to update
 */
function updateAvailability(data, uuid) {
    var lineItem;
    var messages = '';

    for (var i = 0; i < data.items.length; i++) {
        if (data.items[i].UUID === uuid) {
            lineItem = data.items[i];
            break;
        }
    }

    if (lineItem != null) {
        $('.availability-' + lineItem.UUID).empty();

        if (lineItem.availability) {
            if (lineItem.availability.messages && lineItem.availability.messagesTypes[0] === 'restriction') {
                lineItem.availability.messages.forEach(function (message) {
                    messages += '<p class="alert alert-danger line-item-attributes">' + message + '</p>';
                });
            } else {
                lineItem.availability.messages.forEach(function (message) {
                    messages += '<p class="line-item-attributes">' + message + '</p>';
                });
            }
        }

        $('.availability-' + lineItem.UUID).html(messages);
    }
}

/**
 * Finds an element in the array that matches search parameter
 * @param {array} array - array of items to search
 * @param {function} match - function that takes an element and returns a boolean indicating if the match is made
 * @returns {Object|null} - returns an element of the array that matched the query.
 */
function findItem(array, match) { // eslint-disable-line no-unused-vars
    for (var i = 0, l = array.length; i < l; i++) {
        if (match.call(this, array[i])) {
            return array[i];
        }
    }
    return null;
}

/**
 * Updates details of a product line item
 * @param {Object} data - AJAX response from the server
 * @param {string} uuid - The uuid of the product line item to update
 */
function updateProductDetails(data, uuid) {
    $('.card.product-info.uuid-' + uuid).replaceWith(data.renderedTemplate);
}

/**
 * Generates the modal window on the first call.
 *
 */
function getModalHtmlElement() {
    if ($('#editProductModal').length !== 0) {
        $('#editProductModal').remove();
    }
    var htmlString = '<!-- Modal -->'
        + '<div class="modal fade" id="editProductModal" tabindex="-1" role="dialog">'
        + '<span class="enter-message sr-only" ></span>'
        + '<div class="modal-dialog quick-view-dialog modal--added-by-js">'
        + '<!-- Modal content-->'
        + '<div class="modal-content">'
        + '<div class="modal-header">'
        + '    <span class="quick-view-title"></span>'
        + '    <button type="button" class="close pull-right" data-dismiss="modal">'
        + '    </button>'
        + '</div>'
        + '<div class="modal-body"></div>'
        + '</div>'
        + '</div>'
        + '</div>';
    $('body').append(htmlString);
}

/**
 * Parses the html for a modal window
 * @param {string} html - representing the body and footer of the modal window
 *
 * @return {Object} - Object with properties body and footer.
 */
function parseHtml(html) {
    var $html = $('<div>').append($.parseHTML(html));

    var body = $html.find('.product-quickview');
    var footer = $html.find('.modal-footer').children();
    var editTitle = body.data('edit-title');

    return { body: body, footer: footer, editTitle: editTitle };
}

/**
 * replaces the content in the modal window for product variation to be edited.
 * @param {string} editProductUrl - url to be used to retrieve a new product model
 */
function fillModalElement(editProductUrl) {
    var $editModal = $('#editProductModal');
    var $editModalBody = $editModal.find('.modal-body');

    $editModalBody.spinner().start();
    $.ajax({
        url: editProductUrl,
        method: 'GET',
        dataType: 'json',
        success: function (data) {
            var parsedHtml = parseHtml(data.renderedTemplate);

            $editModalBody.empty().html(parsedHtml.body);
            $editModal.find('.quick-view-title').text(parsedHtml.editTitle);
            $editModal.find('.modal-header .close .sr-only').text(data.closeButtonText);
            $editModal.find('.enter-message').text(data.enterDialogMessage);
            $editModal.find('.embroidery-selection').addClass('d-none');
            $(document.body).triggerHandler('globale:updatePrices');
            $editModal.modal('show');
            if (data.product.thresholdMessage !== '') {
                $('.product-threshold-message').removeClass('d-none');
            }
            $('body').trigger('editproductmodal:ready');
            $.spinner().stop();
            addToCartTooltip.init();
            colorSwatchTooltip.init();
            specialSelect.init();
        },
        error: function () {
            $.spinner().stop();
        }
    });
}

/**
 * replace content of modal
 * @param {string} actionUrl - url to be used to remove product
 * @param {string} productID - pid
 * @param {string} productName - product name
 * @param {string} uuid - uuid
 * @param {string} context - cart
 */
function confirmDelete(actionUrl, productID, productName, uuid, context) {
    var $deleteConfirmBtn = $('.cart-delete-confirmation-btn');
    var $productToRemoveSpan = $('.product-to-remove');

    $deleteConfirmBtn.data('pid', productID);
    $deleteConfirmBtn.data('action', actionUrl);
    $deleteConfirmBtn.data('uuid', uuid);
    if (context !== null) {
        $deleteConfirmBtn.data('context', context);
    }
    $productToRemoveSpan.empty().append(productName);
}

/**
 * Shows the summary of added embroideries on a product line item
 * @param {string} html - html template
 * @param {string} pid - pid
 */
function renderAddedEmbroidery(html, pid) {
    let $productLine = $(`.pid-${pid}`);
    let $embroideryLine = $('.embroidery-lineitem-summary', $productLine);
    let $embroideryAddButton = $('.embroidery-lineitem-select', $productLine);
    $embroideryAddButton.hide();
    $embroideryLine.html(html).show();
    $('.embroidery-cart-tooltip').tooltip(tooltipOptions);
    $('.embroidery-shipping-message').show();
}

/**
 * Generates the remove embroidery requst
 * @param {Object} requestData - Data object required for request depending on orignating line item
 */
function removeEmbroidery(requestData) {
    $.spinner().start();
    $('#areyousure').modal('hide');

    if (requestData.url && requestData.pid) {
        $.ajax({
            url: requestData.url,
            method: 'GET',
            data: {
                pid: requestData.pid,
                qty: requestData.qty,
                pliuuid: requestData.pliuuid
            },
            success: function (data) {
                location.reload();
                if (!data.shippingMessage) {
                    $('.embroidery-shipping-message').hide();
                }
            },
            error: function () {
                $.spinner().stop();
            }
        });
    }
}


/**
 * Fixed Cart Summary
 * Uses 'jquery.sticky-kit.min.js' located in 'scripts.ismml'
 */
function fixedCartSummary() {
    $('.cart-order-sticky').stick_in_parent({
        offset_top: $('.sticky-header').outerHeight() - 20
    });
}

/**
 * Gets the save for later list
 * @param {string} url - url to get save for later list
 * @returns {Promise} - Promise object represents the save for later list
 */
function getSaveForlater(url) {
    return new Promise((resolve, reject) => {
        $.ajax({
            url: url,
            method: 'GET',
            success: function (data) {
                resolve(data);
            },
            error: function () {
                reject();
            }
        });
    });
}

module.exports = {

    initializeEvents() {
        // remove sufficient payment message
        // All payment methods are removed in this stage
        window.sessionStorage.removeItem('sufficientPayment');
        // init save for later list
        const saveForLaterContainer = $('.saveforlaterItemContainer');
        /**
         * Toggles the upsell-grid--single modifier class on each .upsell-grid
         * based on the number of currently visible .upsell-container children.
         * @returns {void}
         */
        function updateAllUpsellGrids() {
            $('.upsell-grid').each(function () {
                var visibleCount = $(this).find('.upsell-container:visible').length;
                $(this).toggleClass('upsell-grid--single', visibleCount === 1);
            });
        }

        if (saveForLaterContainer) {
            const url = saveForLaterContainer.data('href');
            $('body').on('saveforlater:reload', function () {
                const saveForLater = getSaveForlater(url);
                saveForLaterContainer.spinner().start();
                saveForLater.then((data) => {
                    saveForLaterContainer.parent().find('> h2.save-for-later-title').remove();
                    $('#showSaveForLaterOne').closest('.save-for-later-title').remove();
                    saveForLaterContainer.html(data);
                    saveForLaterContainer.prev('.save-for-later-feedback').remove();
                    saveForLaterContainer.next('.loggedout-saveforlater').remove();
                    saveForLaterContainer.next('.saveforlaterListEmpty').remove();
                    $('[data-toggle="tooltip"]').tooltip({
                        offset: '0, 20px'
                    });
                    updateAllUpsellGrids();
                }).catch(() => {
                    saveForLaterContainer.spinner().stop();
                });
            });
            $('body').on('saveforlater:updateCartTotals upsell:updateCartTotals', function (e, data) {
                updateCartTotals(data.cart);
                const freeShippingContext = data.freeShippingContext || (data.cart && data.cart.freeShippingContext) || null;
                updateFreeShippingProgressBar(null, {
                    locale: data.locale,
                    items: data.cart.items,
                    freeShippingContext: data.cart.freeShippingContext
                }, freeShippingContext ? freeShippingContext.apiMinFree : null);
            });
            $('#showSaveForLaterOne').one('click', function () {
                saveForLaterContainer.spinner().start();
                $('body').trigger('saveforlater:reload');
            });
            $(document).on('click', '#showSaveForLater', function (e) {
                e.preventDefault();
                if ($(this).hasClass('collapsed')) {
                    $(this).find('i').toggleClass('fa-angle-down fa-angle-up');
                    $(this).removeClass('collapsed');
                } else {
                    $(this).find('i').toggleClass('fa-angle-up fa-angle-down');
                    $(this).addClass('collapsed');
                }
                saveForLaterContainer.find('.cart-lineitem').toggle();

                $('.cart-order-sticky').trigger('sticky_kit:recalc');
            });
        }
        if ($('.shipping-progress-bar').length > 0) {
            var progressBar = $('.shipping-progress-bar');
            updateFreeShippingProgressBar(null, {
                locale: progressBar.data('locale'),
                items: [
                    {
                        price: { sales: { currency: progressBar.data('currency') } }
                    }
                ],
                freeShippingContext: {
                    minFree: Number(progressBar.data('minfree')),
                    merchSubtotal: Number(progressBar.data('subtotal')),
                    shippingRate: Number(progressBar.data('shippingrate')),
                    resources: progressBar.data('resources')
                }
            }, Number(progressBar.data('minfree')));
        }

        $('body').on('cart:update promotion:success saveforlater:promotionSuccess', function (e, data) {
            if ($('.shipping-progress-bar').length > 0) {
                const freeShippingContext = data.freeShippingContext || (data.basket && data.basket.freeShippingContext) || null;
                let totals = data && data.basket ? data.basket.totals : data && data.totals;
                updateFreeShippingProgressBar(e, {
                    locale: data.locale,
                    items: data.basket ? data.basket.items : data.items,
                    freeShippingContext: freeShippingContext || {
                        minFree: Number($('.shipping-progress-bar').data('minfree')),
                        merchSubtotal: totals && totals.subTotal ? Number(totals.subTotal.replace(/[$,]/g, '') || '0') : 0,
                        shippingRate: totals && totals.totalShippingCost ? Number(totals.totalShippingCost.replace(/[$,]/g, '') || '0') : 0,
                        resources: $('.shipping-progress-bar').data('resources')
                    }
                }, freeShippingContext ? freeShippingContext.apiMinFree : null);
            }
            if ('noDiscountMessage' in data) {
                $('.coupon-applied').text(data.noDiscountApplied || '');
                $('#sourceCodeFeedback').text(data.noDiscountMessage || '');
                $('#sourceCodeFeedback').removeClass('d-none');
            }
        });

        $('.embroidery-attribute-text').tooltip(tooltipOptions);
        embroidery.initEmbroideryResumeWatcher();

        $('.embroidery-cart-tooltip, .digitization-cart-tooltip').tooltip(tooltipOptions);
        $('.embroidery-shipping-message').hide();
        qtySelect.initQuantitySelector();

        // Add embroidery table to line item after user completes embroidery flow
        cache.$document.on('cart:addEmbroidery', function (e, embroideryData) {
            renderAddedEmbroidery(embroideryData.html, embroideryData.pid);
        });

        // Show embroidery details
        cache.$document.on('click', '.embroidery-details-toggle', function () {
            $(this).toggleClass('active');
            $(this).parents('.embroidery-lineitem-summary').find('.embroidery-summary-component-list').toggleClass('d-none');
        });

        // Opens the embroidery modal
        cache.$document.on('click', '.embroidery-lineitem-select', function () {
            let pid = $(this).data('pid');
            let pliuuid = $(this).data('pliuuid');
            let $lineWrapper = $(`.uuid-${pliuuid}`);
            let $qtyInput = $lineWrapper.find('.quantity-select');
            let qty = $qtyInput.val() || $(this).data('qty');
            let url = $(this).data('url');
            if (pid && qty && url) {
                // If opening embroidery from minicart, close minicart
                if ($(this).hasClass('minicart-lineitem-select')) {
                    $('.minicart .popover').removeClass('show');
                }

                embroidery.initEmbroideryModal({
                    url,
                    qty,
                    pid,
                    pliuuid,
                    pageContext: 'cart'
                });
            }
        });

        cache.$document.on('click', '.embroidery-summary-edit', function () {
            let pid = $(this).data('pid');
            let pliuuid = $(this).data('pliuuid');
            let $lineWrapper = $(`.uuid-${pliuuid}`);
            let $qtyInput = $lineWrapper.find('.quantity-select');
            let qty = $qtyInput.val() || $(this).data('qty');
            let url = $(this).data('url');
            let embroideryUrl = $(this).data('embroidery-url');

            if (url && pid) {
                $.ajax({
                    url: url,
                    method: 'GET',
                    data: {
                        pid: pid,
                        pliuuid: pliuuid,
                        qty: qty
                    },
                    success: function (data) {
                        if (data) {
                            embroidery.initEmbroideryModal({
                                url: embroideryUrl,
                                qty,
                                pid,
                                pliuuid,
                                pageContext: 'cart',
                                initialData: data
                            });
                        }
                    }
                });
            }
        });

        cache.$document.on('click', '.embroidery-summary-remove', function () {
            let requestData = {
                pid: $(this).data('pid'),
                pliuuid: $(this).data('pliuuid'),
                qty: $(this).data('qty'),
                url: $(this).data('url')
            };

            $('#areyousure').modal('show').data('requestData', requestData);
        });

        cache.$document.on('click', '#areyousure .confirm-action', function () {
            let requestData = $('#areyousure').data('requestData');
            if (requestData) {
                removeEmbroidery(requestData);
            }
        });

        let previewModalCallback;

        // Generate a preview of embroideries corresponding tothis line item
        cache.$document.on('click', '.embroidery-summary-preview', function () {
            let pid = $(this).data('pid');
            let url = $(this).data('url');
            let pliuuid = $(this).data('pliuuid');
            var params = {
                pliuuid: pliuuid,
                pid: pid
            };

            if (url && pid) {
                url = appendToUrl(url, params);
                $.ajax({
                    url,
                    method: 'GET',
                    success: function (response) {
                        if (response) {
                            $('#embroideryPreviewModal').modal('show');
                            previewModalCallback = () => {
                                embroidery.loadPreviewList(response.data, $('#embroideryPreviewModal'), {
                                    color: response.productColor,
                                    image: response.images && response.images[1]
                                });
                            };
                        }
                    }
                });
            }
        });

        // Embroidery previews require the Dom to be visible for width/height calculations
        $('#embroideryPreviewModal').on('shown.bs.modal', function () {
            previewModalCallback();
        });

        var isshippingMessage = $('.embroidery-shipping-message').data('shippingmessage');
        if (isshippingMessage) {
            $('.embroidery-shipping-message').show();
        }

        if (window.matchMedia('(min-width: 992px)').matches) {
            fixedCartSummary();
        }

        $(window).on('resize', function () {
            updateAllUpsellGrids();
        });

        $(window).on('resize', debounce(function () {
            if (window.matchMedia('(min-width: 992px)').matches) {
                fixedCartSummary();
            } else {
                $('.cart-order-sticky').trigger('sticky_kit:detach');
            }
        }, 500));

        $('body').on('upsell:updateCartTotals saveforlater:updateCartTotals', function () {
            updateAllUpsellGrids();
        });

        $('body').on('cart:updateCartTotals', function (e, data) {
            if (data && data.cart) {
                updateCartTotals(data.cart);
                $('.minicart').trigger('count:update', data);
            }
        });

        $('body').on('cart:itemRemoved', function () {
            setTimeout(updateAllUpsellGrids, 0);
        });

        $('body').on('click', '.remove-product', function (e) {
            e.preventDefault();

            var actionUrl = $(this).data('action');
            var productID = $(this).data('pid');
            var productName = $(this).data('name');
            var uuid = $(this).data('uuid');
            var context = $(this).data('context') || null;
            confirmDelete(actionUrl, productID, productName, uuid, context);
        });

        $('body').on('click', '.move-save-for-later', function () {
            var productID = $(this).data('pid');
            var $container = $('.upsell-container[data-upsell-pid="' + productID + '"]');
            if ($container.length) {
                var sentinelClass = $container.hasClass('upsell-container-1') ? 'upsell-saved-for-later-1' : 'upsell-saved-for-later-2';
                $('.saveforlaterItemContainer').append('<div class="d-none ' + sentinelClass + '" aria-hidden="true"></div>');
            }
        });

        $('body').on('click', '.add-to-cart-from-saveforlater', function () {
            var productID = $(this).data('pid');
            var $container = $('.upsell-container[data-upsell-pid="' + productID + '"]');
            if ($container.length) {
                updateAllUpsellGrids();
            }
        });

        $('body').on('click', '.remove-from-saveforlater', function () {
            updateAllUpsellGrids();
        });

        $('body').on({
            click: function () {
                var removeButton = $(this).closest('.product-info').find('.remove-product');
                removeButton.trigger('click');
            },
            mouseover: function () {
                $(this).removeAttr('disabled');
            }
        }, '.cart-page .quantity-module .btn.quantity-decrease.disabled');
        $('.cart-page .quantity-module .quantity.quantity-input').on('change paste keyup', function (e) {
            e.preventDefault();
            var minValue = $(this).attr('min');
            if ($(this).val() === '0') {
                $(this).prev().children('.btn.quantity-decrease').removeAttr('disabled');
                $(this).val(minValue);
                var removeButton = $(this).closest('.product-info').find('.remove-product');
                removeButton.trigger('click');
            }
        });

        $('body').on('afterRemoveFromCart', function (e, data) {
            e.preventDefault();
            confirmDelete(data.actionUrl, data.productID, data.productName, data.uuid);
        });

        $('.optional-promo').click(function (e) {
            e.preventDefault();
            $('.promo-code-form').toggle();
        });

        $('body').on('cart:itemRemoved', function (e, data, uuid) {
            if (data.basket.items.length === 0) {
                location.reload();
            } else {
                if (data.toBeDeletedUUIDs && data.toBeDeletedUUIDs.length > 0) {
                    for (var i = 0; i < data.toBeDeletedUUIDs.length; i++) {
                        $('.uuid-' + data.toBeDeletedUUIDs[i]).remove();
                    }
                }
                var basketItems = data.basket.items;
                var hasEmbroidery = false;
                for (var index = 0; index < basketItems.length; index++) {
                    var emb = basketItems[index].embroidery;
                    if (emb != null && emb.length > 0) {
                        hasEmbroidery = true;
                        break;
                    }
                }
                if (!hasEmbroidery) {
                    $('.embroidery-shipping-message').hide();
                }
                $('.uuid-' + uuid).remove();
                if (!data.basket.hasBonusProduct) {
                    $('.bonus-product').remove();
                }
                $('.coupons-and-promos').empty().append(data.basket.totals.discountsHtml);
                updateCartTotals(data.basket);
                updateApproachingDiscounts(data.basket.approachingDiscounts);
                $('body').trigger('setShippingMethodSelection', data.basket);
                validateBasket(data.basket);
            }

            $('body').trigger('cart:update', data);

            $.spinner().stop();
        });

        $('body').on('click', '.cart-delete-confirmation-btn', function (e) {
            e.preventDefault();

            var productID = $(this).data('pid');
            var productName = $(this).data('name');
            var url = $(this).data('action');
            var uuid = $(this).data('uuid');
            var urlParams = {
                pid: productID,
                uuid: uuid
            };
            if ($(this).data('context')) {
                urlParams.context = $(this).data('context');
            }

            // Capture item data before removal since it won't be in the response
            var $removedItem = $('.uuid-' + uuid);
            var removedItemData = {
                productName: $removedItem.find('.line-item-name').text().trim() || productName,
                brand: $removedItem.data('expbrand') || '',
                subcollection: $removedItem.data('expcategoryname') || ''
            };

            url = appendToUrl(url, urlParams);

            $('body > .modal-backdrop').remove();

            if ($('body').hasClass('modal-open')) {
                $('body').removeAttr('style').removeClass('modal-open');
            }

            $.spinner().start();

            $('body').trigger('cart:beforeUpdate');

            $.ajax({
                url: url,
                type: 'get',
                dataType: 'json',
                success: function (data) {
                    $('body').trigger('cart:itemRemoved', [data, uuid]);
                    var eventData = base.buildExponeaCartUpdateData({
                        action: 'remove',
                        pid: productID,
                        removedItemData: removedItemData
                    }, data.basket || data);
                    $('body').trigger('exponea:updateCart', eventData);
                },
                error: function (err) {
                    if (err.responseJSON && err.responseJSON.redirectUrl) {
                        window.location.href = err.responseJSON.redirectUrl;
                    } else if (err.responseJSON && err.responseJSON.errorMessage) {
                        createErrorNotification(err.responseJSON.errorMessage);
                        $.spinner().stop();
                    } else {
                        window.location.reload();
                    }
                }
            });
        });

        $('body').on('change', '.quantity-form > .quantity', function () {
            var preSelectQty = $(this).data('pre-select-qty');
            var quantity = $(this).val();
            var productID = $(this).data('pid');
            var url = $(this).data('action');
            var uuid = $(this).data('uuid');

            var urlParams = {
                pid: productID,
                quantity: quantity,
                uuid: uuid
            };
            url = appendToUrl(url, urlParams);
            var parentElement = $(this).parents('.card').length > 0 ? $(this).parents('.card') : $(this).parents('.cart');
            parentElement.spinner().start();

            $('body').trigger('cart:beforeUpdate');

            $.ajax({
                url: url,
                type: 'get',
                context: this,
                dataType: 'json',
                success: function (data) {
                    $('.quantity[data-uuid="' + uuid + '"]').val(quantity);
                    $('.coupons-and-promos').empty().append(data.totals.discountsHtml);
                    updateCartTotals(data);
                    updateApproachingDiscounts(data.approachingDiscounts);
                    updateAvailability(data, uuid);
                    validateBasket(data);
                    var $this = $(this);

                    $this.data('pre-select-qty', quantity);
                    $('.cart-error').empty();
                    $('body').trigger('cart:update', data);
                    var eventData = base.buildExponeaCartUpdateData({
                        action: 'update',
                        pid: productID
                    }, data);
                    $('body').trigger('exponea:updateCart', eventData);

                    $.spinner().stop();
                    if ($this.parents('.product-info').hasClass('bonus-product-line-item') && $('.cart-page').length) {
                        location.reload();
                    }

                    // Keeping the Cart and Minicart quantity fields in sync
                    if ($('.cart-page').length > 0) {
                        var $updatedQuantityElements = $this.parent('.quantity-form').clone(true);

                        $('.product-cart-item .uuid-' + uuid + ', .minicart-content .uuid-' + uuid)
                            .find('.quantity-form').replaceWith($updatedQuantityElements);
                    }
                    return true;
                },
                error: function (err) {
                    if (err.responseJSON.redirectUrl) {
                        window.location.href = err.responseJSON.redirectUrl;
                    } else {
                        createErrorNotification(err.responseJSON.errorMessage);
                        $(this).val(parseInt(preSelectQty, 10));
                        $(this).parent().find('.quantity-input').val(parseInt(preSelectQty, 10));
                        $.spinner().stop();
                    }
                }
            });
        });

        $('.shippingMethods').change(function () {
            var url = $(this).attr('data-actionUrl');
            var urlParams = {
                methodID: $(this).find(':selected').attr('data-shipping-id')
            };
            // url = appendToUrl(url, urlParams);

            $('.totals').spinner().start();
            $('body').trigger('cart:beforeShippingMethodSelected');
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: urlParams,
                success: function (data) {
                    if (data.error) {
                        window.location.href = data.redirectUrl;
                    } else {
                        $('.coupons-and-promos').empty().append(data.totals.discountsHtml);
                        updateCartTotals(data);
                        updateApproachingDiscounts(data.approachingDiscounts);
                        validateBasket(data);
                    }

                    $('body').trigger('cart:shippingMethodSelected', data);
                    $.spinner().stop();
                },
                error: function (err) {
                    if (err.redirectUrl) {
                        window.location.href = err.redirectUrl;
                    } else {
                        createErrorNotification(err.responseJSON.errorMessage);
                        $.spinner().stop();
                    }
                }
            });
        });

        let appliedCode;

        $('.promo-code-form').submit(function (e) {
            e.preventDefault();
            $.spinner().start();
            var $form = $(this);
            var $codeField = $form.find('.coupon-code-field');
            var enteredCode = $codeField.val();
            var isCouponCode = recycleCouponCode.isRecycleCouponCode(enteredCode);
            var submitUrl = $form.attr('action');

            $form.find('.coupon-missing-error').hide();
            $form.find('.coupon-error-message').empty();
            if (!enteredCode) {
                $form.find('.form-control').addClass('is-invalid');
                $form.find('.form-control').attr('aria-describedby', 'missingCouponCode');
                $form.find('.coupon-missing-error').show();
                $.spinner().stop();
                return false;
            }

            if (isCouponCode) {
                var formattedCoupon = recycleCouponCode.formatRecycleCodeValue(enteredCode);
                $codeField.val(formattedCoupon);
                if (formattedCoupon.length !== recycleCouponCode.RECYCLE_CODE_LENGTH) {
                    $form.find('.form-control').addClass('is-invalid');
                    $form.find('.form-control').attr('aria-describedby', 'missingCouponCode');
                    $form.find('.coupon-missing-error').show();
                    $.spinner().stop();
                    return false;
                }
                submitUrl = $form.data('add-coupon-url') || submitUrl;
            }

            $form.find('.form-control').removeClass('is-invalid');
            $form.find('.coupon-error-message').empty();
            $('body').trigger('promotion:beforeUpdate');
            var form = $form.serializeArray();
            if (appliedCode) {
                form.push({
                    name: 'appliedCode',
                    value: appliedCode
                });
            }
            if (isCouponCode) {
                form.push({
                    name: 'sourcePage',
                    value: $('#checkout-main').length ? 'checkout' : 'cart'
                });
            }
            $.ajax({
                url: submitUrl,
                type: 'GET',
                dataType: 'json',
                data: form,
                success: function (data) {
                    if (data.error) {
                        $form.find('.form-control').addClass('is-invalid');
                        $form.find('.form-control').attr('aria-describedby', 'invalidCouponCode');
                        $form.find('.coupon-error-message').empty().append(data.errorMessage);
                        $('body').trigger('promotion:error', data);
                    } else {
                        if (!isCouponCode) {
                            $('.cart-sourcecode-form-container').hide();
                            $('.optional-promo').hide();
                            $('.coupons-and-promos.source-code-list').empty().append(data.totals.discountsHtml);
                        }
                        updateCartTotals(data);
                        updateApproachingDiscounts(data.approachingDiscounts);
                        validateBasket(data);
                        $('body').trigger('promotion:success', data);
                        $('#shippingMethods').html(changeShippingMethods(data.shipments[0]));
                        // update checkout shipping methods if visible
                        updateShippingMethodsOnCheckout();
                    }
                    $form.find('.coupon-code-field').val('');
                    $.spinner().stop();
                },
                error: function (err) {
                    $('body').trigger('promotion:error', err);
                    if (err.responseJSON.redirectUrl) {
                        window.location.href = err.responseJSON.redirectUrl;
                    } else {
                        createErrorNotification(err.errorMessage);
                        $.spinner().stop();
                    }
                }
            });
            return false;
        });

        $('body').on('click', '.remove-coupon-code, .remove-coupon', function (e) {
            e.preventDefault();
            var $btn = $(this);
            var couponCode = $btn.data('code');
            var uuid = $btn.data('uuid');
            var action = $btn.data('action');
            var $deleteConfirmBtn = $('.delete-coupon-confirmation-btn');
            var $modal = $('#removeCouponModal');
            var isSourceCode = action && action.indexOf('SourceCode') > -1;

            $deleteConfirmBtn.removeAttr('data-removal-kind');
            $deleteConfirmBtn.removeAttr('data-store-credit-remove-url');

            if (isSourceCode) {
                $modal.find('.modal-title').text($modal.data('sourcecode-heading'));
                $modal.find('.remove-modal-body-text').text($modal.data('sourcecode-body'));
            } else {
                $modal.find('.modal-title').text($modal.data('coupon-heading'));
                $modal.find('.remove-modal-body-text').text($modal.data('coupon-body'));
            }

            appliedCode = '';
            $deleteConfirmBtn.data('uuid', uuid);
            $deleteConfirmBtn.data('code', couponCode);
            $deleteConfirmBtn.data('action', action);
            $('.coupon-to-remove').empty().append(couponCode).show();
        });

        $('body').on('click', '.delete-coupon-confirmation-btn', function (e) {
            var $confirm = $(this);
            if ($confirm.attr('data-removal-kind') === 'storecredit') {
                e.preventDefault();
                var scUrl = $confirm.attr('data-store-credit-remove-url');
                if (!scUrl) {
                    return;
                }
                var tokenInput = $('.giftcard-content input[name="csrf_token"]');
                var postData = {};
                if (tokenInput.length && tokenInput.attr('name') && tokenInput.val()) {
                    postData[tokenInput.attr('name')] = tokenInput.val();
                }
                $('body > .modal-backdrop').remove();
                $.spinner().start();
                $('body').trigger('promotion:beforeUpdate');
                $.ajax({
                    url: scUrl,
                    type: 'POST',
                    data: postData,
                    dataType: 'json',
                    success: function (data) {
                        $.spinner().stop();
                        if (data.error) {
                            $('#balance-result > span').html(data.errorMessage || 'Error');
                            $('#balance-result').removeClass('d-none');
                            return;
                        }
                        $confirm.removeAttr('data-removal-kind');
                        $confirm.removeAttr('data-store-credit-remove-url');
                        if (data.totals) {
                            var summaryHelpers = require('../checkout/summary');
                            summaryHelpers.updateTotals(data.totals);
                            $('body').trigger('promotion:success', { totals: data.totals });
                        }
                        $('#store-credit-wallet-block').addClass('d-none');
                        $('#balance-result > span').empty();
                        $('#balance-result').addClass('d-none');
                        $('#payment-message').addClass('d-none');
                        $('#removeCouponModal').modal('hide');
                    },
                    error: function (err) {
                        $('body').trigger('promotion:error', err);
                        $.spinner().stop();
                        var msg = (err.responseJSON && err.responseJSON.errorMessage) || err.statusText || 'Error';
                        $('#balance-result > span').html(msg);
                        $('#balance-result').removeClass('d-none');
                    }
                });
                return;
            }

            var action = $(this).data('action');
            if (!action) {
                return;
            }
            e.preventDefault();

            var url = $(this).data('action');
            var uuid = $(this).data('uuid');
            var couponCode = $(this).data('code');
            var isSourceCodeRemoval = url && String(url).indexOf('SourceCode') > -1;
            url = appendToUrl(url, {
                code: couponCode,
                uuid: uuid,
                sourcePage: $('#checkout-main').length ? 'checkout' : 'cart'
            });

            $('body > .modal-backdrop').remove();
            $.spinner().start();
            $('body').trigger('promotion:beforeUpdate');
            $.ajax({
                url: url,
                type: 'get',
                dataType: 'json',
                success: function (data) {
                    $('.coupon-uuid-' + uuid).remove();
                    var $giftcardsContent = $('#giftcert-content');
                    if ($giftcardsContent.length && !$giftcardsContent.find('.certificate-item').length) {
                        $giftcardsContent.find('.certificate-label').remove();
                    }
                    $('#balance-result > span').empty();
                    $('#balance-result').addClass('d-none');
                    $('#payment-message').addClass('d-none');
                    if (isSourceCodeRemoval) {
                        $('.cart-sourcecode-form-container').show();
                        $('.optional-promo').show();
                        $('.cart-unique-sourcecode').hide();
                        $('.source-code-cancel').addClass('d-none');
                        $('.promo-code-submit').removeClass('d-flex align-items-center');
                    }
                    updateCartTotals(data);
                    updateApproachingDiscounts(data.approachingDiscounts);
                    validateBasket(data);
                    if (data.shipments && data.shipments[0]) {
                        $('#shippingMethods').html(changeShippingMethods(data.shipments[0]));
                    }
                    updateShippingMethodsOnCheckout();
                    $('body').trigger('promotion:success', data);
                    $('#removeCouponModal').modal('hide');
                    $.spinner().stop();
                },
                error: function (err) {
                    $('body').trigger('promotion:error', err);
                    if (err.responseJSON && err.responseJSON.redirectUrl) {
                        window.location.href = err.responseJSON.redirectUrl;
                    } else {
                        createErrorNotification((err.responseJSON && err.responseJSON.errorMessage) || 'Error');
                        $.spinner().stop();
                    }
                }
            });
        });

        $('body').on('click', '.cart-page .bonus-product-button', function () {
            $.spinner().start();
            $(this).addClass('launched-modal');
            $.ajax({
                url: $(this).data('url'),
                method: 'GET',
                dataType: 'json',
                success: function (data) {
                    base.methods.editBonusProducts(data);
                    $.spinner().stop();
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        });

        $('body').on('hidden.bs.modal', '#chooseBonusProductModal', function () {
            $('#chooseBonusProductModal').remove();
            $('.modal-backdrop').remove();
            $('body').removeClass('modal-open');

            if ($('.cart-page').length) {
                $('.launched-modal .btn-outline-primary').trigger('focus');
                $('.launched-modal').removeClass('launched-modal');
            } else {
                $('.product-detail .add-to-cart').focus();
            }
        });

        $('body').on('click', '.cart-page .product-edit .edit, .cart-page .bundle-edit .edit', function () {
            var editProductUrl = $(this).data('url');

            getModalHtmlElement();
            fillModalElement(editProductUrl);
        });

        $('body').on('shown.bs.modal', '#editProductModal', function () {
            $('#editProductModal').siblings().attr('aria-hidden', 'true');
            $('#editProductModal .close').focus();
        });

        $('body').on('hidden.bs.modal', '#editProductModal', function () {
            $('#editProductModal').siblings().attr('aria-hidden', 'false');
        });

        $('body').on('keydown', '#editProductModal', function (e) {
            var focusParams = {
                event: e,
                containerSelector: '#editProductModal',
                firstElementSelector: '.close',
                lastElementSelector: '.update-cart-product-global',
                nextToLastElementSelector: '.modal-footer .quantity-select'
            };
            focusHelper.setTabNextFocus(focusParams);
        });

        $('body').on('product:updateAddToCart', function (e, response) {
            // update global add to cart (single products, bundles)
            var dialog = $(response.$productContainer)
                .closest('.quick-view-dialog');

            $('.update-cart-product-global', dialog).attr('disabled',
                !$('.global-availability', dialog).data('ready-to-order')
                || !$('.global-availability', dialog).data('available')
            );
        });

        $('body').on('product:updateAvailability', function (e, response) {
            // bundle individual products
            $('.product-availability', response.$productContainer)
                .data('ready-to-order', response.product.readyToOrder)
                .data('available', response.product.available)
                .find('.availability-msg');

            var attrLength = response.product.variationAttributes.length;
            var hasSize = false;
            for (var i = 0; i < attrLength; i++) {
                var attr = response.product.variationAttributes[i].attributeId;
                if (attr === 'size') {
                    hasSize = true;
                }
            }
            if (response.product.availability.messagesTypes && response.product.availability.messagesTypes[0] !== 'restriction' && response.product.thresholdMessage.length > 0 && hasSize) {
                $('.product-threshold-message').empty().html(response.product.thresholdMessage).removeClass('d-none');
                $('.availability-msg').empty().addClass('d-none');
            } else {
                $('.availability-msg', response.$productContainer)
                    .empty().html(response.message).removeClass('d-none');
                $('.product-threshold-message').empty().addClass('d-none');
            }

            var dialog = $(response.$productContainer)
                .closest('.quick-view-dialog');

            if ($('.product-availability', dialog).length) {
                // bundle all products
                var allAvailable = $('.product-availability', dialog).toArray()
                    .every(function (item) { return $(item).data('available'); });

                var allReady = $('.product-availability', dialog).toArray()
                    .every(function (item) { return $(item).data('ready-to-order'); });

                $('.global-availability', dialog)
                    .data('ready-to-order', allReady)
                    .data('available', allAvailable);

                $('.global-availability .availability-msg', dialog).empty()
                    .html(allReady ? response.message : response.resources.info_selectforstock);
            } else {
                // single product
                $('.global-availability', dialog)
                    .data('ready-to-order', response.product.readyToOrder)
                    .data('available', response.product.available)
                    .find('.availability-msg')
                    .empty()
                    .html(response.message);
            }
        });

        $('body').on('product:beforeAttributeSelect', function () {
            $('#editProductModal .modal-content').spinner().start();
        });

        $('body').on('product:afterAttributeSelect', function (e, response) {
            if ($('.modal.show .product-quickview .bundle-items').length) {
                $('.modal.show').find(response.container).data('pid', response.data.product.id);
                $('.modal.show').find(response.container).find('.product-id').text(response.data.product.id);
            } else {
                var upChargeTextArray = response.data.product.upChargeText;
                var upChargeText = '';
                for (var index = 0; index < upChargeTextArray.length; index++) {
                    upChargeText += upChargeTextArray[index] + '\n';
                }
                var upChargeTextSelector = $('.modal.show .product-quickview').find('.size-extra-price');
                // control over the UpCharge text
                if (!response.data.product.hideUpChargeText) {
                    if (response.data.product.isVariant) {
                        if (!upChargeTextSelector.hasClass('d-none')) {
                            upChargeTextSelector.addClass('d-none');
                        }
                    } else {
                        if (upChargeTextSelector.hasClass('d-none')) { // eslint-disable-line
                            upChargeTextSelector.removeClass('d-none');
                        }
                    }
                }
                $('.modal.show .product-quickview').data('pid', response.data.product.id);
                $('.modal.show .product-quickview').find('.size-extra-price').empty().append(upChargeText);
                $('.modal.show .product-quickview').find('.style').text('STYLE #' + response.data.product.id);
                $('.modal.show .product-quickview .primary-images').find('img').attr('src', response.data.product.images.quickView[0].url);
                $('.modal.show .product-quickview .zoom-hires').data('zoom-url', response.data.product.imagesZoom.pdpZoom[0].url);

                // Event rules defined on base.js
                if ($('#editProductModal.show').length > 0) {
                    $(document.body).triggerHandler('globale:updatePrices');
                }
            }
        });

        $('body').on('change', '.quantity-select', function () {
            var selectedQuantity = $(this).val();
            $('.modal.show .update-cart-url').data('selected-quantity', selectedQuantity);
        });

        $('body').on('change', '.options-select', function () {
            var selectedOptionValueId = $(this).children('option:selected').data('value-id');
            $('.modal.show .update-cart-url').data('selected-option', selectedOptionValueId);
        });

        $('body').on('click', '.update-cart-product-global', function (e) {
            e.preventDefault();

            var updateProductUrl = $(this).closest('.cart-and-ipay').find('.update-cart-url').val();
            var selectedQuantity = $(this).closest('.cart-and-ipay').find('.update-cart-url').data('selected-quantity');
            var selectedOptionValueId = $(this).closest('.cart-and-ipay').find('.update-cart-url').data('selected-option');
            var uuid = $(this).closest('.cart-and-ipay').find('.update-cart-url').data('uuid');

            var form = {
                uuid: uuid,
                pid: base.getPidValue($(this)),
                quantity: selectedQuantity,
                selectedOptionValueId: selectedOptionValueId
            };

            $(this).parents('.card, #editProductModal .modal-content').spinner().start();

            $('body').trigger('cart:beforeUpdate');

            if (updateProductUrl) {
                $.ajax({
                    url: updateProductUrl,
                    type: 'post',
                    context: this,
                    data: form,
                    dataType: 'json',
                    success: function (data) {
                        $('.coupons-and-promos').empty().append(data.cartModel.totals.discountsHtml);
                        updateCartTotals(data.cartModel);
                        updateApproachingDiscounts(data.cartModel.approachingDiscounts);
                        updateAvailability(data.cartModel, uuid);
                        updateProductDetails(data, uuid);

                        if (data.uuidToBeDeleted) {
                            $('.uuid-' + data.uuidToBeDeleted).remove();
                        }

                        validateBasket(data.cartModel);
                        window.location.href = data.redirectUrl;
                        $('body').trigger('cart:update', data);
                        var eventData = base.buildExponeaCartUpdateData({
                            action: 'update',
                            pid: form.pid
                        }, data.cartModel);
                        $('body').trigger('exponea:updateCart', eventData);
                    },
                    error: function (err) {
                        if (err.responseJSON.redirectUrl) {
                            window.location.href = err.responseJSON.redirectUrl;
                        } else if (base.isSizeSelectionError(err.responseJSON.errorMessage, $(this).closest('.modal-content'))) {
                            base.showPdpSizeValidationError($(this).closest('.modal-content'), err.responseJSON.errorMessage, false);
                        } else {
                            cartEditErrorNotification(err.responseJSON.errorMessage);
                        }
                        $.spinner().stop();
                    }
                });
            }
        });

        // Change source code event handler
        $('body').on('click', '.cart-change-code', function (e) {
            e.preventDefault();
            var placeholder = $('.coupon-code-field').data('placeholderupdated');
            $('.coupon-code-field').attr('placeholder', placeholder);
            $('.cart-sourcecode-form-container').show();
            $('.optional-promo').show();
            $('.cart-unique-sourcecode').hide();
            $('#sourceCodeFeedback').addClass('d-none');
            $('.source-code-cancel').removeClass('d-none');
            $('.promo-code-submit').addClass('d-flex align-items-center');
            appliedCode = $('.remove-coupon').data('code');
            window.console.log(placeholder);
        });

        // Cancel source code event handler
        $('body').on('click', '.source-code-cancel-link', function (e) {
            e.preventDefault();
            var placeholder = $('.coupon-code-field').data('placeholder');
            $('.coupon-code-field').attr('placeholder', placeholder);
            $('.cart-sourcecode-form-container').hide();
            $('.optional-promo').hide();
            $('.cart-unique-sourcecode').show();
            $('#sourceCodeFeedback').removeClass('d-none');
            $('.source-code-cancel').addClass('d-none');
            $('.promo-code-submit').removeClass('d-flex align-items-center');
        });

        // GlobalE international shipping selection

        // Check if user lands on cart requesting international shipping
        let hadInternationalRequest = window.sessionStorage.getItem('internationalShipping');

        // Open GlobalE international select modal
        if (hadInternationalRequest) {
            if (window.gle) {
                window.gle('ShippingSwitcher', 'show');
            }
            $('#gle_selectedCountry').val(hadInternationalRequest).trigger('change');
        }

        // Delete request for international shipping once user handles the modal
        $(document).on('GlobalE:switcherClose', function () {
            if (hadInternationalRequest) {
                window.sessionStorage.removeItem('internationalShipping');
            }
        });

        base.selectAttribute();
        base.colorAttribute();
        base.sizeAttribute();
        base.removeBonusProduct();
        base.selectBonusProduct();
        base.enableBonusProductSelection();
        base.showMoreBonusProducts();
        base.addBonusProductsToCart();
        base.focusChooseBonusProductModal();
        base.trapChooseBonusProductModalFocus();
        base.onClosingChooseBonusProductModal();
        base.globaleUpdatePrice();
        base.alertBackInStock();
        base.addToCartUpsell();

        $('.upsell-grid').each(function () {
            var visibleCount = $(this).find('.upsell-container:visible').length;
            $(this).toggleClass('upsell-grid--single', visibleCount === 1);
        });
    }

};
